import { extractQueryAsParamsFromUrl as _extractQueryAsParamsFromUrl } from './urlHelpers';

const getCacheQueryStringParamsFromUrl = () => {
  let lastExtractedQueryParams: { url: string; params: Record<string, string> };

  const extractQueryAsParamsFromUrl = (url: string): Record<string, string> => {
    if (lastExtractedQueryParams?.url === url) {
      return lastExtractedQueryParams.params;
    }
    const params = _extractQueryAsParamsFromUrl(url);
    lastExtractedQueryParams = { url, params };
    return params;
  };

  return { extractQueryAsParamsFromUrl };
};

export const queryStringParamsCache = getCacheQueryStringParamsFromUrl();
